import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  private currentBrand: 'cmillonario' | 'midiadesuerte' = 'cmillonario';

  constructor(private titleService: Title, private metaService: Meta) {
    this.detectBrand();
  }

  detectBrand() {
    // En la rama feature/solo-loteria, todos los dominios usan el layout de lotería.
    // El layout de casino/sportsbook vive en la rama 'issues'.
    this.currentBrand = 'midiadesuerte';
    this.applyDocumentSettings();
  }

  getBrand(): 'cmillonario' | 'midiadesuerte' {
    return this.currentBrand;
  }

  isMidiadesuerte(): boolean {
    return this.currentBrand === 'midiadesuerte';
  }

  getAppName(): string {
    return this.isMidiadesuerte() ? 'Mi Día de Suerte' : 'cmillonario';
  }

  getWelcomeText(): string {
    if (this.isMidiadesuerte()) {
      return '¡Bienvenido a Mi Día de Suerte! Juega a tus sorteos favoritos de Lotería Nacional y Pronósticos. ¿Listo para tu próxima victoria?';
    }
    return '¡Vive la emoción en tiempo real! entra a Casino para girar y ganar, o apuesta en SportsBook y celebra cada jugada. ¿Listo para tu próxima victoria?';
  }

  getFooterLegalText(): string {
    if (this.isMidiadesuerte()) {
      return 'www.midiadesuerte.com.mx Operada en México por Producciones Móviles S.A. de C.V., titular del permiso DGAJS/SCEVF/P-06/2005-TER en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los oficios DGJS/1580/2021 y DGJS/DCRCA/2090/2022. Juegos prohibidos para menores de edad, juegue responsablemente, no olvide que el principal propósito es la recreación, diversión y esparcimiento.';
    }
    return 'www.cmillonario.mx Operada en México por Producciones Móviles S.A. de C.V., titular del permiso DGAJS/SCEVF/P-06/2005-TER en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los oficios DGJS/1580/2021 y DGJS/DCRCA/2090/2022. Juegos prohibidos para menores de edad, juegue responsablemente, no olvide que el principal propósito es la recreación, diversión y esparcimiento.';
  }

  private applyDocumentSettings() {
    const body = document.body;
    if (this.isMidiadesuerte()) {
      if (body) {
        body.classList.add('brand-midiadesuerte');
        body.classList.remove('brand-cmillonario');
      }
      this.titleService.setTitle('Mi Día de Suerte | Tu lotería nacional favorita');
      this.metaService.updateTag({
        name: 'description',
        content:
          'Juega los mejores sorteos de Lotería Nacional y Pronósticos: Melate, Tris, Chispazo, Progol y más en Mi Día de Suerte.',
      });
    } else {
      if (body) {
        body.classList.add('brand-cmillonario');
        body.classList.remove('brand-midiadesuerte');
      }
      this.titleService.setTitle('Cmillonario | Tu millonario favorito');
      this.metaService.updateTag({
        name: 'description',
        content:
          'Los mejores Slots, vive la adrenalina del Casino en Vivo con Blackjack y Ruleta. Miles de apuestas para todas las ligas y los mejores eventos.',
      });
    }
  }
}
